import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccordianService {

  private accordianSource = new BehaviorSubject<object>({});
  currentAccordian = this.accordianSource.asObservable();

  constructor() { }

  changeAccordian(reach) {
    let tempAcc = this.currentAccordian;
    if (tempAcc[reach]) {
      tempAcc[reach] = !tempAcc[reach];
    } else {
      tempAcc[reach] = true;
    }
    this.accordianSource.next(tempAcc);
  }

}
